/**
 * @generated SignedSource<<b87f0ffd38e621b2742d655307924f63>>
 * @relayHash 8387e0661b8b019d099befa3c97fa9a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5e6f628c5ed79ed0d7e1206f7545ec83f24e5978f77bba20dedeacfb9bbe4511

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraDeleteProjectNotificationPreferencesInput = {
  projectId: string;
};
export type projectNotificationsRemoveButton_removeMutation$variables = {
  cloudId: string;
  input: JiraDeleteProjectNotificationPreferencesInput;
};
export type projectNotificationsRemoveButton_removeMutation$data = {
  readonly jira: {
    readonly deleteProjectNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly projectPreferences: {
        readonly id: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type projectNotificationsRemoveButton_removeMutation = {
  response: projectNotificationsRemoveButton_removeMutation$data;
  variables: projectNotificationsRemoveButton_removeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraDeleteProjectNotificationPreferencesPayload",
        "kind": "LinkedField",
        "name": "deleteProjectNotificationPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          },
          {
            "concreteType": "JiraNotificationProjectPreferences",
            "kind": "LinkedField",
            "name": "projectPreferences",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "projectNotificationsRemoveButton_removeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "projectNotificationsRemoveButton_removeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5e6f628c5ed79ed0d7e1206f7545ec83f24e5978f77bba20dedeacfb9bbe4511",
    "metadata": {},
    "name": "projectNotificationsRemoveButton_removeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "33cec3d8a7498cc5f2bcb6a1f9673b71";

export default node;
